(() => {
  const selector = '[data-master-works]';

  const init = (root) => {
    if (root.dataset.masterWorksReady === 'true') return;

    const rail = root.querySelector('.sgl-master-works__rail');
    const stage = root.querySelector('.sgl-master-works__stage');
    const previous = root.querySelector('[data-master-works-previous]');
    const next = root.querySelector('[data-master-works-next]');
    const items = Array.from(root.querySelectorAll('.sgl-master-work'));

    if (!rail || !stage || !previous || !next || items.length === 0) return;

    root.dataset.masterWorksReady = 'true';
    root.classList.toggle('sgl-master-works--single', items.length === 1);

    const featuredIndex = items.findIndex((item) => item.classList.contains('sgl-master-work--featured'));
    let currentIndex = featuredIndex >= 0 ? featuredIndex : 0;
    let pointerStartX;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    root.classList.toggle('sgl-master-works--reduced-motion', reduceMotion.matches);

    const updateLayout = () => {
      window.requestAnimationFrame(() => {
        const active = items[currentIndex];
        if (!active) return;
        const focusArea = active.querySelector('.sgl-master-work__media') || active;
        const stageRect = stage.getBoundingClientRect();
        const focusRect = focusArea.getBoundingClientRect();

        rail.style.height = `${Math.ceil(active.offsetHeight + 28)}px`;
        stage.style.setProperty(
          '--sgl-master-control-top',
          `${Math.round(focusRect.top - stageRect.top + focusRect.height / 2)}px`
        );
      });
    };

    const show = (requestedIndex) => {
      currentIndex = (requestedIndex + items.length) % items.length;
      const previousIndex = (currentIndex - 1 + items.length) % items.length;
      const nextIndex = (currentIndex + 1) % items.length;

      items.forEach((item, index) => {
        item.classList.toggle('is-active', index === currentIndex);
        item.classList.toggle('is-previous', items.length > 2 && index === previousIndex);
        item.classList.toggle('is-next', items.length > 1 && index === nextIndex);
        item.setAttribute('aria-hidden', index === currentIndex ? 'false' : 'true');
      });

      rail.dataset.currentIndex = String(currentIndex);
      updateLayout();
    };

    const move = (direction) => show(currentIndex + direction);

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));

    rail.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        move(-1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        move(1);
      }
    });

    rail.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerStartX = event.clientX;
    });

    rail.addEventListener('pointerup', (event) => {
      if (pointerStartX === undefined) return;
      const distance = event.clientX - pointerStartX;
      pointerStartX = undefined;

      if (Math.abs(distance) < 44) return;
      move(distance < 0 ? 1 : -1);
    });

    rail.addEventListener('pointercancel', () => {
      pointerStartX = undefined;
    });

    items.forEach((item) => {
      item.querySelectorAll('img').forEach((image) => {
        image.draggable = false;
        if (!image.complete) image.addEventListener('load', updateLayout, { once: true });
      });
    });

    window.addEventListener('resize', updateLayout, { passive: true });
    show(currentIndex);
  };

  const initWithin = (scope) => {
    if (scope.matches && scope.matches(selector)) init(scope);
    if (scope.querySelectorAll) scope.querySelectorAll(selector).forEach(init);
  };

  if (window.SGLMasterWorks) {
    window.SGLMasterWorks.initWithin(document);
    return;
  }

  window.SGLMasterWorks = { initWithin };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document), { once: true });
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
})();
